<template>
  <el-table-column
    v-if="!hide"
    :align="align"
    :label="label"
    :prop="prop"
    :fixed="fixed"
    :show-overflow-tooltip="toolTip"
    :type="type"
    :width="width"
  >
    <template v-if="type != 'selection' && type != 'index'" #default="{row}">
      <div v-if="dataType">
        <!-- select 或 tab 选择项的处理 -->
        <div v-if="dataType == 'select' || dataType == 'tab' || dataType == 'option'">
        <span v-for="(item) in options" :key="item.value">
          <el-tag :type="item.type" v-if="item.value === propValue(row, prop)" disable-transitions>
              {{ item.label }}
          </el-tag>
        </span>
        </div>
        <span v-else-if="dataType == 'money'">￥{{(propValue(row, prop) / 100).toFixed(2)}}</span>
        <!-- 处理用户头像  -->
        <template v-else-if="dataType === DataType.AVATAR">
          <el-avatar :src="propValue(row, prop)"></el-avatar>
        </template>
        <!-- 处理图片  -->
        <template v-else-if="dataType === DataType.IMAGE">
          <el-image style="width: 50px; height: 50px" :src="propValue(row, prop)"
                    :preview-teleported="true" fit="fill" :preview-src-list="[propValue(row, prop)]"></el-image>
        </template>
        <!-- 处理base64图片  -->
        <template v-else-if="dataType === DataType.IMAGE_BASE64">
          <el-image style="width: 50px; height: 50px" :src="`data:image/png;base64,${propValue(row, prop)}`"
                    :preview-teleported="true" fit="fill"
                    :preview-src-list="[`data:image/png;base64,${propValue(row, prop)}`]"></el-image>
        </template>
        <span v-else>{{ propValue(row, prop) }}</span>
      </div>
      <div v-else>
        <slot v-if="defaultSlot" name="default" :row="row"></slot>
        <!-- 不使用插槽，显示默认值 -->
        <span v-else>{{ propValue(row, prop) }}</span>
      </div>
    </template>
    <slot v-if="!!this.$slots.default" name="default"></slot>
    <template v-if="!!this.$slots.header" #header>
      <slot name="header"></slot>
    </template>
  </el-table-column>
</template>

<script>
import { DataType } from '@/components/ExTable/ExTableEnum'

export default {
  name: 'ExTableColumn',
  computed: {
    DataType() {
      return DataType
    },
    toolTip() {
      if (typeof this.showOverflowTooltip === 'string') {
        if (this.showOverflowTooltip === "") {
          return true;
        }
        return this.showOverflowTooltip === "true";
      } else if (typeof this.showOverflowTooltip === 'boolean') {
        return this.showOverflowTooltip;
      } else return false;
    },
    defaultSlot() {
      return !!(this.$scopedSlots && this.$scopedSlots.default);
    },
  },
  inject: {
    fun: "table-pagination"
  },
  props: {
    search: {
      type: Boolean,
      default: true,
    },
    searchKey: String,
    dataType: String,
    options: Array,
    align: String,
    label: String,
    prop: String,
    fixed: String,
    showOverflowTooltip: {
      default: false,
      type: [String, Boolean]
    },
    multiple: {
      default: false,
      type: [String, Boolean]
    },
    type: {
      type: String,
      default: 'default',
      validator: (value) => ["default", "selection", "index", "expand"].includes(value),
    },
    startTimeKey: String,
    endTimeKey: String,
    hide: {
      default: false,
      type: Boolean
    },
    width: String,
  },
  watch: {
    searchKey: {
      handler() {
        if (this.searchKey) {
          this.fun && this.fun({
            key: this.searchKey,
            search: this.search,
            label: this.label,
            type: this.dataType,
            options: this.options,
            startTimeKey: this.startTimeKey,
            endTimeKey: this.endTimeKey,
            showOverflowTooltip: this.showOverflowTooltip,
            multiple: this.multiple,
          });
        }
      },
      immediate: true
    },
    options: {
      handler() {
        if (this.searchKey) {
          this.fun && this.fun({
            key: this.searchKey,
            search: this.search,
            label: this.label,
            type: this.dataType,
            options: this.options,
            startTimeKey: this.startTimeKey,
            endTimeKey: this.endTimeKey,
            showOverflowTooltip: this.showOverflowTooltip,
            multiple: this.multiple,
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    content(row, key = "") {
      let keys = key.split(".");

      const find = (vo, key = "") => {
        let info = vo[key];
        let req = keys.shift();
        if (info && req) {
          return find(info, req);
        }

        return vo[key] || '';
      }

      return find(row, keys.shift());
    },
    propValue(row, key = "") {
      return row[key];
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ExTable/ex-table-column.vue